
export const reCaptcha = new Promise((resolve, reject) => {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${window.reCaptcha.siteKey}`;
  resolve(document.head.appendChild(script));
  setTimeout(() => reject(new Error('Google reCaptcha не инициализирована')), 3000);
});

export function reCaptchaToken() {
  return new Promise(resolve => {
    reCaptcha.then(() => {
      if (window.reCaptcha.siteKey) {
        setTimeout(() => {
          grecaptcha.ready(() => {
            grecaptcha
              .execute(window.reCaptcha.siteKey, { action: 'submit' })
              .then(token => {
                resolve(token);
              })
              .catch(rej => {
                console.log(rej);
                resolve(false);
              });
          });
        }, 1000);
      } else {
        resolve(false);
      }
    });
  });
}
